import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  title: {},
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#FFFFFF1A',
    color: 'text.primaryDark',
    padding: {
      xs: '20px',
      md: '32px',
    },
    borderRadius: '16px',
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    color: 'text.primaryDark',

    gap: '8px',
  },
  icon: {
    position: 'relative',
    flexShrink: 0,
    width: '48px !important',
    height: '48px !important',
    minWidth: '48px',
    minHeight: '48px',
    maxWidth: '48px',
    maxHeight: '48px',
    overflow: 'hidden',
    '& img': {
      objectFit: 'contain !important',
      width: '48px !important',
      height: '48px !important',
    },
  },
  description: {
    color: 'text.primaryDark',
    opacity: '0.6',
    textAlign: 'center',
  },
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
